const routes = [
    {
        path: "/course/registration/reservation/",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            isSpecialStudent:false
        }
    },
    {
        path: "/course/registration/reservation/:id",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        },
    },
    {
        path: "/course/registration/reservation/exchange/",
        component: () => import("../pages/Exchange.vue"),
        meta: {
            isAuthenticated: true,
            isStudent: true,
            isSpecialStudent:false
        }
    },
    {
        path: "/course/registration/reservation/exchange/:id",
        component: () => import("../pages/Exchange.vue"),
        meta: {
            isAuthenticated: true
        },
    }
];

export default routes;
